import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FORMULES } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";

export default function FormulesSection() {
  const { requestEstimate } = useDialogs();

  return (
    <section id="formules" data-testid="formules-section" className="py-14 md:py-20 px-4 md:px-8 bg-graylight">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Nos formules</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3 mb-3">
            Choisissez le niveau d'accompagnement adapté
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            Vous pouvez disposer uniquement du véhicule, bénéficier de l'aide du chauffeur ou nous confier l'ensemble de la prestation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5 items-stretch">
          {FORMULES.map((formule, i) => (
            <motion.div
              key={formule.key}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              data-testid={`formule-card-${formule.key}`}
              className={`bg-white rounded-2xl p-6 md:p-7 flex flex-col ${
                formule.highlighted ? "border-2 border-navy" : "border border-gray-200"
              }`}
            >
              <h3 className="font-heading font-bold text-lg text-navy mb-2 leading-snug">{formule.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-5">{formule.text}</p>
              <ul className="space-y-2 mb-5 flex-1">
                {formule.includes.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-navy/85">
                    <Check className="w-4 h-4 text-orange shrink-0 mt-0.5" /> {item}
                  </li>
                ))}
              </ul>
              {formule.note && (
                <p className="text-xs text-muted-foreground italic border-t border-gray-100 pt-3 mb-5">{formule.note}</p>
              )}
              <Button
                data-testid={`formule-cta-${formule.key}`}
                onClick={() => requestEstimate({ formule: formule.value, source: `formules-${formule.key}` })}
                className={`rounded-full font-semibold justify-between ${
                  formule.highlighted
                    ? "bg-orange hover:bg-orange-hover text-white"
                    : "bg-navy hover:bg-navy/90 text-white"
                }`}
              >
                {formule.cta} <ArrowRight className="w-4 h-4" />
              </Button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
